// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3axlF","errors":"Errors_errors__kGvQc"};